import { EcosystemServiceModel } from "@shared/models/ecosystem-service.model";

export const _12_EROSION:Partial<EcosystemServiceModel> ={
  id:'erosion',
  pos:12,
  image: "/images/ecoservices/erosion.jpg",
  code: ["2.2.1.1"],
  unit:'erosion',
  assetType:'other',
  serviceType: 'regulating',
  valuationMethods:[
    {
      id: 'benefitTransfer',
      name:"Benefit Transfer",
      unit: "tons",
      element: "avoided erosion",
      altUnits: null,
      qtyIndices: [
        { id: "quality", name: "Quality Index", included: true },
      ],
      valueIndices: []
    }
  ]

}
